import { connect } from 'react-redux';
import MonthlyActivityPlanRapbs from '../../../../views/Finance/Budgeting/MonthlyActivityPlan/MonthlyActivityPlanRapbs.finance.view';
// import { getFundRequest, deleteFundRequest } from '../../../../states/thunks/finance.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // handleGetFundRequest: (payload, unit_id) => dispatch(getFundRequest(payload, unit_id)),
    // handleDelete: payload => dispatch(deleteFundRequest(payload)),
    // handleGet: payload => dispatch(getFundRequest(payload)),
  };
}

export default connect(null, mapDispatchToProps)(MonthlyActivityPlanRapbs);
